/**
 * Typographie des textes venus d'ailleurs (traductions de la v1, messages du serveur, réglages du BO) affichés par la
 * v2, sans toucher à leur source (flag éteint : la v1 garde ses textes) — revue du 05/10.
 * - apostrophe droite → typographique (’) entre deux lettres ;
 * - espace (ou absence d'espace) devant « ? ! : ; » → espace insécable U+00A0 (U+202F, absente de la police du thème,
 *   est rendue sur 0,6 px dans WebKit : « annuler? ») ; une heure (« 12:30 ») ou une adresse (« https: ») n'est pas
 *   touchée ;
 * - « e-mail » insécable (voir E_MAIL).
 */
const NBSP = '\u00a0';

/**
 * « e-mail » insécable : trait d'union suivi d'un gluon (U+2060, WORD JOINER, sans glyphe), la ligne ne se coupe plus
 * après « e- » (revue du 05/10 : « … un e- / mail avec votre lien », Chromium, texte équilibré). Le trait d'union
 * insécable U+2011 n'existe pas dans la police du thème (Helvetica Neue LT) : il serait pris dans une autre police.
 */
export const E_MAIL = 'e-\u2060mail';
export const E_MAIL_CAP = 'E-\u2060mail';

export function typo(text: string): string;
export function typo(text: string | null | undefined): string | undefined;
export function typo(text: string | null | undefined): string | undefined {
  if (text == null) return undefined;
  return (
    text
      .replace(/(\p{L})'(?=\p{L})/gu, '$1’')
      // « mot : », « mot? », « mot ! » : l'espace ordinaire, fine ou absente devant la ponctuation haute devient insécable.
      .replace(/(\p{L}|[»)%€\d])[ \u202f]?([?!;])/gu, `$1${NBSP}$2`)
      .replace(/(\p{L}|[»)%€])[ \u202f]?:(?!\/\/)/gu, `$1${NBSP}:`)
      .replace(/(\d) :/g, `$1${NBSP}:`)
      .replace(/\b([eE])-mail/g, '$1-\u2060mail')
  );
}
